// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

import PortFolioTypes from './portfolio-report.type';

/** ***************GET PORTFOLIO AT RISK START ************* */
export const getPortfolioReportDetailsStart = (getData: any) => ({
	type: PortFolioTypes.PORTFOLIO_REPORT_START,
	payload: getData,
});

export const getPortfolioReportDetailsSuccess = (successData: any) => ({
	type: PortFolioTypes.PORTFOLIO_REPORT_SUCCESS,
	payload: successData,
});

export const getPortfolioReportDetailsFailure = (failureData: any) => ({
	type: PortFolioTypes.PORTFOLIO_REPORT_FAILURE,
	payload: failureData,
});

export const getPortfolioReportDetailsResponseResetStart = () => ({
	type: PortFolioTypes.PORTFOLIO_REPORT_RESPONSE_RESET,
});

export const getPortfolioReportDetailsResponseChanged = () => ({
	type: PortFolioTypes.PORTFOLIO_REPORT_RESPONSE_CHANGED,
});
/** ***************GET PORTFOLIO AT RISK END ************* */
